// import React, { useState, useEffect } from "react";
// import Card from "../card/Card";
// import { useFetchAllCategoryQuery, useFetchAllFilteredProductsQuery } from "../../store/api/ProductSlice";

// function AllProducts() {
//   const [category, setCategory] = useState("");
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(1);

//   // Fetch products with filters and pagination
//   const { data, isLoading, error } = useFetchAllFilteredProductsQuery({
//     category,
//     minPrice,
//     maxPrice,
//     searchTerm,
//     page,
//     limit: 70,
//   });



//   const { data: categoryData } = useFetchAllCategoryQuery();

//   const handleCategoryChange = (e) => setCategory(e.target.value);
//   const handleMinPriceChange = (e) => setMinPrice(e.target.value);
//   const handleMaxPriceChange = (e) => setMaxPrice(e.target.value);
//   const handleSearchTermChange = (e) => setSearchTerm(e.target.value);


//   const handlePageChange = (newPage) => {
//     if (newPage > 0 && newPage <= data?.pagination?.totalPages) {
//       setPage(newPage);
//     }
//   };

//   useEffect(() => {
   
//     if (page > 1 && page <= data?.pagination?.totalPages) {
//       setPage(page);
//     }
//   }, [category, minPrice, maxPrice, searchTerm, page, data]);

//   return (
//     <div
//       id=""
//       className="bg-gray-50 lg:py-16 py-10 mx-auto max-w-screen-2xl px-3 sm:px-10"
//     >
//       {/* Filters Section */}
//       <div className="mb-10 bg-white p-6 rounded-lg shadow-lg -mt-10 border border-gray-100">
//         <h3 className="text-2xl font-semibold mb-6 text-center text-gray-900">
//           Filter Products
//         </h3>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//           {/* Category Filter */}
//           <div className="space-y-2">
//             <label
//               htmlFor="category"
//               className="text-sm font-medium text-gray-700"
//             >
//               Category
//             </label>
//             <select
//               id="category"
//               className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:scale-105 appearance-none"
//               onChange={handleCategoryChange}
//               value={category}
//             >
//               <option value="">Select Category</option>
//               {categoryData &&
//                 categoryData.map((category) => (
//                   <option key={category._id} value={category.name}>
//                     {category.parent}
//                   </option>
//                 ))}
//             </select>
//             <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="16"
//                 height="16"
//                 fill="currentColor"
//                 className="bi bi-caret-down-fill text-gray-700"
//                 viewBox="0 0 16 16"
//               >
//                 <path d="M1.5 4a.5.5 0 0 1 .8-.4L8 8.567 13.7 3.6a.5.5 0 1 1 .6.8l-5 5.5a.5.5 0 0 1-.6 0l-5-5.5a.5.5 0 0 1-.4-.8z" />
//               </svg>
//             </div>
//           </div>

//           <div className="space-y-2">
//             <label
//               htmlFor="minPrice"
//               className="text-sm font-medium text-gray-700"
//             >
//               Min Price
//             </label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-3 flex items-center">
//                 <span className="text-gray-700">$</span>
//               </div>
//               <input
//                 type="number"
//                 id="minPrice"
//                 className="w-full p-3 pl-7 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 pr-10"
//                 placeholder="Min Price"
//                 value={minPrice}
//                 onChange={(e) => handleMinPriceChange(e)}
//               />
//               <div className="absolute inset-y-0 right-2 flex flex-col justify-center items-center ">
//                 <button
//                   type="button"
//                   className="text-gray-700 hover:bg-gray-200 rounded-full "
//                   onClick={() => setMinPrice((prev) => Number(prev) + 1)}
//                 >
//                   ▲
//                 </button>
//                 <button
//                   type="button"
//                   className="text-gray-700 hover:bg-gray-200 rounded-full "
//                   onClick={() =>
//                     setMinPrice((prev) => Math.max(0, Number(prev) - 1))
//                   }
//                 >
//                   ▼
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Max Price Filter */}
//           <div className="space-y-2">
//             <label
//               htmlFor="maxPrice"
//               className="text-sm font-medium text-gray-700"
//             >
//               Max Price
//             </label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-3 flex items-center">
//                 <span className="text-gray-700">$</span>
//               </div>
//               <input
//                 type="number"
//                 id="maxPrice"
//                 className="w-full p-3 pl-7 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 pr-10"
//                 placeholder="Max Price"
//                 value={maxPrice}
//                 onChange={(e) => handleMaxPriceChange(e)}
//               />

//               <div className="absolute inset-y-0 right-2 flex flex-col justify-center items-center">
//                 <button
//                   type="button"
//                   className="text-gray-700 hover:bg-gray-200 rounded-full"
//                   onClick={() => setMaxPrice((prev) => Number(prev) + 1)}
//                 >
//                   ▲
//                 </button>
//                 <button
//                   type="button"
//                   className="text-gray-700 hover:bg-gray-200 rounded-full"
//                   onClick={() =>
//                     setMaxPrice((prev) => Math.max(0, Number(prev) - 1))
//                   }
//                 >
//                   ▼
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Search Term Filter */}
//           <div className="space-y-2">
//             <label
//               htmlFor="searchTerm"
//               className="text-sm font-medium text-gray-700"
//             >
//               Search By Brand or Flavour
//             </label>
//             <input
//               type="text"
//               id="searchTerm"
//               placeholder="Search products"
//               className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:scale-105"
//               value={searchTerm}
//               onChange={handleSearchTermChange}
//             />
//           </div>
//         </div>
//       </div>

//       {/* Product List */}
//       <div className="flex">
//         <div className="w-full">
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
//   {isLoading ? (
//     <div className="flex items-center justify-center space-x-2">
//       <div className="w-6 h-6 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
//       <span className="text-lg font-semibold text-gray-700">Loading...</span>
//     </div>
//   ) : (
//     data?.products
//       ?.filter((product) => product?.status === "Show")
//       ?.map((product) => <Card key={product._id} data={product} />)
//   )}
// </div>

//         </div>
//       </div>

//       {/* Pagination Controls */}
//       <div className="pagination-controls flex items-center justify-center space-x-4 mt-6">
//         {/* Previous Button */}
//         <button
//           disabled={page === 1}
//           onClick={() => handlePageChange(page - 1)}
//           className="btn-prev px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md shadow-md disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-blue-700 transition-all duration-200 ease-in-out"
//         >
//           Previous
//         </button>

//         {/* Page Info */}
//         <span className="page-info text-sm font-medium text-gray-700">
//           Page {page} of {data?.pagination?.totalPages || 1}
//         </span>

//         {/* Next Button */}
//         <button
//           disabled={page === data?.pagination?.totalPages}
//           onClick={() => handlePageChange(page + 1)}
//           className="btn-next px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md shadow-md disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-blue-700 transition-all duration-200 ease-in-out"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// }

// export default AllProducts;





import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  FiChevronDown,
  FiGrid,
  FiList,
  FiShoppingBag,
  FiSearch,
} from "react-icons/fi";

import Card from "../card/Card";
import { useFetchAllFilteredProductsQuery } from "../../store/api/ProductSlice";
import ShopSidebar from "./ShopSidebar";

import ShopBanner from "../../assets/img/ShopBanner.png";
import BottomBanner from "../../assets/img/ShopBanner1.png";

import FlowerImage from "../../assets/img/Flower.png";
import PreRollsImage from "../../assets/img/Pre-rolls.png";
import EdiblesImage from "../../assets/img/Edible.png";
import ConcentratesImage from "../../assets/img/Concentrates.png";
import TincturesImage from "../../assets/img/Oils.png";
import TopicalsImage from "../../assets/img/Topicals.png";
import CBDImage from "../../assets/img/CBD.png";

const DEBUG = true;
const PAGE_LIMIT = 70;

const categoryItems = [
  { name: "Flower", image: FlowerImage, category: "Flower" },
  { name: "Pre-Rolls", image: PreRollsImage, category: "Pre-Rolls" },
  { name: "Edibles", image: EdiblesImage, category: "Edibles" },
  { name: "Concentrates", image: ConcentratesImage, category: "Concentrates" },
  { name: "Tinctures & Oils", image: TincturesImage, category: "Tinctures & Oils" },
  { name: "Topicals", image: TopicalsImage, category: "Topicals" },
  { name: "CBD Products", image: CBDImage, category: "CBD Products" },
];

const getSearchValue = (params, key) => params.get(key) || "";

const getSearchValues = (params, key) =>
  params.getAll(key).filter(Boolean);

function AllProducts() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [sortBy, setSortBy] = useState("newest");
  const [view, setView] = useState("grid");

  const [filterDraft, setFilterDraft] = useState({
    productName: getSearchValue(searchParams, "productName"),
    searchTerm: getSearchValue(searchParams, "searchTerm"),
    brand: getSearchValue(searchParams, "brand"),
    flavor: getSearchValue(searchParams, "flavor"),
    seller: getSearchValue(searchParams, "seller"),
  });

  const category = getSearchValues(searchParams, "category");
  const minPrice = getSearchValue(searchParams, "minPrice");
  const maxPrice = getSearchValue(searchParams, "maxPrice");

  const productName = getSearchValue(searchParams, "productName");
  const searchTerm = getSearchValue(searchParams, "searchTerm");

  const brand = getSearchValues(searchParams, "brand");
  const flavor = getSearchValues(searchParams, "flavor");
  const seller = getSearchValues(searchParams, "seller");

  const inStock = getSearchValue(searchParams, "inStock");
  const onSale = getSearchValue(searchParams, "onSale");

  const page = Math.max(
    parseInt(searchParams.get("page"), 10) || 1,
    1
  );

  const queryArgs = useMemo(
    () => ({
      category,
      minPrice,
      maxPrice,
      productName,
      searchTerm,
      brand,
      flavor,
      seller,
      inStock,
      onSale,
      page,
      limit: PAGE_LIMIT,
    }),
    [
      category.join("|"),
      minPrice,
      maxPrice,
      productName,
      searchTerm,
      brand.join("|"),
      flavor.join("|"),
      seller.join("|"),
      inStock,
      onSale,
      page,
    ]
  );

  const {
    data,
    isLoading,
    isFetching,
    error,
    isError,
  } = useFetchAllFilteredProductsQuery(queryArgs);

  // Keep form inputs synchronized with sidebar and browser navigation.
  useEffect(() => {
    setFilterDraft({
      productName: getSearchValue(searchParams, "productName"),
      searchTerm: getSearchValue(searchParams, "searchTerm"),
      brand: getSearchValue(searchParams, "brand"),
      flavor: getSearchValue(searchParams, "flavor"),
      seller: getSearchValue(searchParams, "seller"),
    });
  }, [searchParams]);

  useEffect(() => {
    if (!DEBUG) return;

    console.groupCollapsed("[AllProducts] API request");
    console.log("Query arguments:", queryArgs);
    console.log("Current URL:", window.location.href);
    console.groupEnd();
  }, [queryArgs]);

  useEffect(() => {
    if (!DEBUG) return;

    console.groupCollapsed("[AllProducts] API response");
    console.log("Loading:", isLoading);
    console.log("Fetching:", isFetching);
    console.log("Data:", data);
    console.log("Error:", error);

    if (error) {
      console.error("API error details:", error);
    }

    console.groupEnd();
  }, [data, error, isLoading, isFetching]);

  // Normalize invalid page values.
  useEffect(() => {
    const rawPage = searchParams.get("page");

    if (
      rawPage !== null &&
      (!Number.isInteger(Number(rawPage)) || Number(rawPage) < 1)
    ) {
      const next = new URLSearchParams(searchParams);
      next.delete("page");
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const products = data?.products || [];
  const totalProducts = data?.pagination?.totalProducts ?? 0;
  const totalPages = Math.max(data?.pagination?.totalPages || 1, 1);

  const updateDraft = (key, value) => {
    setFilterDraft((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Apply top-form filters without losing sidebar selections.
  const applyFilters = () => {
    const next = new URLSearchParams(searchParams);

    // These are single-value fields controlled by the top form.
    ["productName", "searchTerm"].forEach((key) => next.delete(key));

    if (filterDraft.productName.trim()) {
      next.set("productName", filterDraft.productName.trim());
    }

    if (filterDraft.searchTerm.trim()) {
      next.set("searchTerm", filterDraft.searchTerm.trim());
    }

    // Replace a filter only when the top-form input has a value.
    // Otherwise preserve sidebar-selected values.
    const textFilters = [
      ["brand", filterDraft.brand],
      ["flavor", filterDraft.flavor],
      ["seller", filterDraft.seller],
    ];

    textFilters.forEach(([key, value]) => {
      if (value.trim()) {
        next.delete(key);
        next.set(key, value.trim());
      }
    });

    next.delete("page");

    if (DEBUG) {
      console.log(
        "[AllProducts] Applying filters:",
        Object.fromEntries(next.entries())
      );
    }

    setSearchParams(next);
  };

  const clearFilters = () => {
    setFilterDraft({
      productName: "",
      searchTerm: "",
      brand: "",
      flavor: "",
      seller: "",
    });

    setSearchParams(new URLSearchParams());
  };

  const selectCategory = (selectedCategory) => {
    const next = new URLSearchParams(searchParams);
    const currentCategories = next.getAll("category");

    next.delete("category");

    const updatedCategories = currentCategories.includes(selectedCategory)
      ? currentCategories.filter((item) => item !== selectedCategory)
      : [...currentCategories, selectedCategory];

    updatedCategories.forEach((item) => {
      next.append("category", item);
    });

    next.delete("page");
    setSearchParams(next);
  };

  const changePage = (newPage) => {
    if (newPage < 1 || newPage > totalPages || isFetching) {
      return;
    }

    const next = new URLSearchParams(searchParams);

    if (newPage === 1) {
      next.delete("page");
    } else {
      next.set("page", String(newPage));
    }

    setSearchParams(next);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const sortedProducts = [...products].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        return Number(a.price || 0) - Number(b.price || 0);

      case "price-high":
        return Number(b.price || 0) - Number(a.price || 0);

      case "name":
        return (a.title || "").localeCompare(b.title || "");

      case "newest":
      default:
        return (
          new Date(b.createdAt || 0).getTime() -
          new Date(a.createdAt || 0).getTime()
        );
    }
  });

  const handleFilterKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      applyFilters();
    }
  };

  return (
    <div className="min-h-screen bg-[#faf9f7] text-[#242126]">
      <div className="mx-auto max-w-[1500px] px-3 py-4 sm:px-5 lg:px-7">
        {/* Top banner */}
        <section className="mb-5 w-full overflow-hidden rounded-2xl">
          <img
            src={ShopBanner}
            alt="Shop Banner"
            className="block h-auto w-full"
          />
        </section>

    

        {/* Category cards */}
        <section className="mb-7">
          <div className="mb-3 flex items-center justify-between">
            <h2 className="text-base font-extrabold sm:text-lg">
              Shop by Category
            </h2>

            <button
              type="button"
              onClick={clearFilters}
              className="text-xs font-semibold text-[#7027df] hover:underline"
            >
              View All
            </button>
          </div>

          <div className="grid grid-cols-4 gap-2 sm:grid-cols-4 md:grid-cols-7 md:gap-3">
            {categoryItems.map((item) => {
              const isSelected = category.includes(item.category);

              return (
                <button
                  type="button"
                  key={item.name}
                  onClick={() => selectCategory(item.category)}
                  aria-pressed={isSelected}
                  className={`group min-w-0 overflow-hidden rounded-xl border bg-white text-center transition hover:-translate-y-0.5 hover:shadow-md ${
                    isSelected
                      ? "border-[#7027df] ring-1 ring-[#7027df]"
                      : "border-gray-100"
                  }`}
                >
                  <div className="aspect-square overflow-hidden bg-gray-100">
                    <img
                      src={item.image}
                      alt={item.name}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>

                  <p className="truncate px-1 py-2 text-[10px] font-semibold sm:text-xs">
                    {item.name}
                  </p>
                </button>
              );
            })}
          </div>
        </section>

        {/* Main layout */}
        <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-[210px_minmax(0,1fr)] lg:grid-cols-[235px_minmax(0,1fr)]">
          <aside className="min-w-0">
            <ShopSidebar products={products} />
          </aside>

          <main className="min-w-0">
            {/* Top search form */}
       

            {/* Product toolbar */}
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
              <div>
                <h1 className="text-lg font-extrabold sm:text-xl">
                  Shop Products
                </h1>
              
              </div>

              <div className="flex items-center gap-2">
                <label
                  htmlFor="product-sort"
                  className="hidden text-xs text-gray-500 sm:block"
                >
                  Sort by:
                </label>

                <div className="relative">
                  <select
                    id="product-sort"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="max-w-[155px] appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-8 text-xs outline-none focus:border-[#7027df]"
                  >
                    <option value="newest">Newest</option>
                    <option value="price-low">Price: Low to High</option>
                    <option value="price-high">Price: High to Low</option>
                    <option value="name">Name: A to Z</option>
                  </select>
                  <FiChevronDown className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-500" />
                </div>

                <button
                  type="button"
                  onClick={() => setView("grid")}
                  aria-label="Grid view"
                  aria-pressed={view === "grid"}
                  className={`rounded-lg border p-2 ${
                    view === "grid"
                      ? "border-[#7027df] bg-[#7027df] text-white"
                      : "border-gray-200 bg-white text-gray-600"
                  }`}
                >
                  <FiGrid size={16} />
                </button>

                <button
                  type="button"
                  onClick={() => setView("list")}
                  aria-label="List view"
                  aria-pressed={view === "list"}
                  className={`rounded-lg border p-2 ${
                    view === "list"
                      ? "border-[#7027df] bg-[#7027df] text-white"
                      : "border-gray-200 bg-white text-gray-600"
                  }`}
                >
                  <FiList size={16} />
                </button>
              </div>
            </div>

            {/* API error */}
            {isError && (
              <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
                <p className="font-bold">Failed to load products.</p>
                <p className="mt-1">
                  Check the browser console for API error details.
                </p>
                {error?.status && (
                  <p className="mt-1">Status: {String(error.status)}</p>
                )}
              </div>
            )}

            {/* Product results */}
            {isLoading ? (
              <div className="flex min-h-52 items-center justify-center gap-3 text-sm text-gray-600">
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-[#7027df] border-t-transparent" />
                Loading products...
              </div>
            ) : sortedProducts.length > 0 ? (
              <div
                className={
                  view === "grid"
                    ? "grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
                    : "flex flex-col gap-3"
                }
              >
                {sortedProducts.map((product, index) => (
                  <div
                    key={product._id || product.id || index}
                    className={
                      view === "list"
                        ? "min-w-0 rounded-xl border border-gray-100 bg-white p-2"
                        : "min-w-0"
                    }
                  >
                    <Card data={product} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="rounded-2xl border border-gray-200 bg-white px-5 py-14 text-center">
                <FiShoppingBag
                  className="mx-auto mb-3 text-gray-400"
                  size={32}
                />
                <h2 className="text-base font-bold text-gray-800">
                  No products found
                </h2>
                <p className="mt-2 text-sm text-gray-500">
                  Try another product name, brand, flavour, or seller.
                </p>
                <button
                  type="button"
                  onClick={clearFilters}
                  className="mt-4 rounded-lg bg-[#7027df] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#5920b5]"
                >
                  Clear Filters
                </button>
              </div>
            )}

            {/* Pagination */}
            {!isLoading && totalPages > 1 && (
              <div className="mt-8 flex items-center justify-center gap-4">
                <button
                  type="button"
                  disabled={page <= 1 || isFetching}
                  onClick={() => changePage(page - 1)}
                  className="rounded-lg bg-[#7027df] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#5920b5] disabled:cursor-not-allowed disabled:bg-gray-300"
                >
                  Previous
                </button>

                <span className="text-xs text-gray-600">
                  Page {page} of {totalPages}
                </span>

                <button
                  type="button"
                  disabled={page >= totalPages || isFetching}
                  onClick={() => changePage(page + 1)}
                  className="rounded-lg bg-[#7027df] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#5920b5] disabled:cursor-not-allowed disabled:bg-gray-300"
                >
                  Next
                </button>
              </div>
            )}
          </main>
        </div>

        {/* Bottom banner */}
        <section className="mt-8 w-full overflow-hidden rounded-2xl">
          <img
            src={BottomBanner}
            alt="Featured collection"
            loading="lazy"
            className="block h-auto w-full"
          />
        </section>
      </div>
    </div>
  );
}

export default AllProducts;
